import { getDefaultHeaders, http } from '../../../utils/apiRequests';

// TODO: Refactor as part of Bridge SDK
export interface Workspace {
  objectUUID: string;
  createTime?: number;
  lastUpdateTime?: number;
  serviceOwner: string;
  keys?: {};
  createTimeString?: string;
  lastUpdateTimeString?: string;
  orderBy?: number;
  delete?: number;
  name: string;
  state: string;
}

export const getWorkspaceWorkflows = async (
  workspaceUUID: string,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const url = `/api/workspace/${workspaceUUID}/workflows`;

  const config = {
    method: 'get',
    headers: getDefaultHeaders(),
  };

  const response = await httpFunc(url, config);
  const json = await response.json();

  return json;
};

export const getWorkspace = async (
  workspaceUUID: string,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const url = `/api/workspace/${workspaceUUID}`;

  const config = {
    method: 'get',
    headers: getDefaultHeaders(),
  };

  const response = await httpFunc(url, config);
  const json = await response.json();

  return json;
};
